import Customer from "../model/Customer";
import { ICustomerSlider, defaultTaskData, IDefaultTaskData, IDefaultActivityData, defaultActivityData, initData } from "./CustomerSliderContext";


class CustomerSliderContainerService {

    public getUnSavedChanges = (customerSlider : ICustomerSlider, existingCustomer : Customer) : any => {
        let changes = {};

        if (this.isAnyUnsavedChangeInActivityTab(customerSlider)) {
            changes['activityPage'] = true;
        }

        if (this.isAnyUnsavedChangeInContacts(customerSlider, existingCustomer)) {
            changes['contactPage'] = true;
        }

        if (this.isAnyUnsavedChagneInNotesTab(customerSlider)) {
            changes['notePage'] = true;
        }

        if (this.isAnyUnsavedChagneInTaskPage(customerSlider)) {
            changes['taskPage'] = true;
        }

        return changes;
    }

    public isAnyUnsavedChangeInActivityTab = (customerSlider : ICustomerSlider) : boolean => {
        let initActivityData: IDefaultActivityData =  defaultActivityData;
        let activity = customerSlider.activityPage.activity;
        if (activity.activityTypeId
            || activity.description?.trim()
            || activity.claimId?.trim()
            || ((initActivityData.activityEffDate != null && activity.activityEffDate !=null) && (initActivityData.activityEffDate.setMilliseconds(0) !=   activity.activityEffDate.setMilliseconds(0)))
            ||  ((initActivityData.policyId !=null && activity.policyId != null) && initActivityData.policyId != activity.policyId )
        ) {
                return true;
        }

        return false;
    }

    public isAnyUnsavedChagneInNotesTab = (customerSlider : ICustomerSlider) : boolean => {
         let initMemoData =  initData.notePage.customerNote;
        let customerNote = customerSlider.notePage.customerNote;
        if (customerNote.note 
            || (initMemoData.noteDate != null && initMemoData.noteDate !=   customerNote.noteDate)
        ) {
                return true;
        }

        return false;
    }

    public isAnyUnsavedChangeInContacts = (customerSlider : ICustomerSlider, existingCustomer : Customer) : boolean => {

        let customerObjOnContactScreen = customerSlider.contactPage.customer;

        if (Object.keys(customerObjOnContactScreen).length == 0) {
            return false;
        }

        if (customerObjOnContactScreen.smsOptOut != existingCustomer.smsOptOut
            || customerObjOnContactScreen.emailOptOut != existingCustomer.emailOptOut
            || customerObjOnContactScreen.mailOptOut != existingCustomer.mailOptOut
            || customerObjOnContactScreen.eddOptIn != existingCustomer.eddOptIn
            || customerObjOnContactScreen.callOptOut != existingCustomer.callOptOut
            || customerObjOnContactScreen.mobile != existingCustomer.mobile
            || customerObjOnContactScreen.mobileSmsOptIn != existingCustomer.mobileSmsOptIn
            || customerObjOnContactScreen.workPhone != existingCustomer.workPhone
            || customerObjOnContactScreen.workPhoneSmsOptIn != existingCustomer.workPhoneSmsOptIn
            || customerObjOnContactScreen.homePhone != existingCustomer.homePhone
            || customerObjOnContactScreen.otherPhone1 != existingCustomer.otherPhone1
            || customerObjOnContactScreen.otherPhone1SmsOptIn != existingCustomer.otherPhone1SmsOptIn
            || customerObjOnContactScreen.otherPhone2 != existingCustomer.otherPhone2
            || customerObjOnContactScreen.otherPhone2SmsOptIn != existingCustomer.otherPhone2SmsOptIn
            || customerObjOnContactScreen.otherPhone3 != existingCustomer.otherPhone3
            || customerObjOnContactScreen.otherPhone3SmsOptIn != existingCustomer.otherPhone3SmsOptIn
            || customerObjOnContactScreen.eMail?.trim() != existingCustomer.eMail?.trim()
            || customerObjOnContactScreen.eMail2?.trim() != existingCustomer.eMail2?.trim()
            || customerObjOnContactScreen.email3?.trim() != existingCustomer.email3?.trim()
            || customerObjOnContactScreen.email4?.trim() != existingCustomer.email4?.trim()
            || customerObjOnContactScreen.email5?.trim() != existingCustomer.email5?.trim()
            || customerObjOnContactScreen.address1?.trim() != existingCustomer.address1?.trim()
            || customerObjOnContactScreen.address2?.trim() != existingCustomer.address2?.trim()
            || customerObjOnContactScreen.city?.trim() != existingCustomer.city?.trim()
            || customerObjOnContactScreen.zipCode?.trim() != existingCustomer.zipCode?.trim()
        )
        {
                return true;
        }

        return false;
    }

    public isAnyUnsavedChagneInTaskPage = (customerSlider : ICustomerSlider) : boolean => {

        let initTaskData: IDefaultTaskData =  defaultTaskData;

        let taskDto = customerSlider.taskPage.customerTask;
        if (
            taskDto.description?.trim().length > 0 ||
            taskDto.claimId ||
            ((initTaskData.ccUserId !=   ""  && customerSlider.taskPage.customerTask.ccUserId != undefined) && initTaskData.ccUserId != customerSlider.taskPage.customerTask.ccUserId) || 
            ((initTaskData.companyId !=  "" &&  customerSlider.taskPage.customerTask.companyId != undefined) && initTaskData.companyId != customerSlider.taskPage.customerTask.companyId) || 
            ((initTaskData.priorityId != "" &&  customerSlider.taskPage.customerTask.priorityId != undefined) && initTaskData.priorityId != customerSlider.taskPage.customerTask.priorityId) || 
            ((initTaskData.statusId !=   "" &&  customerSlider.taskPage.customerTask.statusId != undefined) && initTaskData.statusId != customerSlider.taskPage.customerTask.statusId) || 
            ((initTaskData.toUserId !=   "" &&  customerSlider.taskPage.customerTask.toUserId != undefined) && initTaskData.toUserId != customerSlider.taskPage.customerTask.toUserId) ||
            ((initTaskData.dueDate !=   "" &&  customerSlider.taskPage.customerTask.dueDate != undefined) && initTaskData.dueDate != customerSlider.taskPage.customerTask.dueDate) 
        ) {
                return true;
        }

        return false;
    }
}

export default CustomerSliderContainerService;